// extracted by mini-css-extract-plugin
module.exports = {"Game":"Game_Game__2P9KR","current_game":"Game_current_game__W85bS"};